function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import SurveyDropdown from './dropdown';
import SurveyTextField from './textfield';
import SurveyGrade from './grade';
import SurveyRadio from './radio';
import { Scrollbars } from 'react-custom-scrollbars';
import SurveyButton from './button';
import { hexToRgb, rgb_is_light, standardize_color } from '../utils';
var SurveyBackground = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  justify-content: flex-end;\n  align-items: center;\n  display: flex;\n  background-color: rgba(51,51,51,0.5);\n  top: 0px; right: 0px; bottom: 0px; left: 0px;\n  z-index: 450;\n"])));
var SurveyWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  height: 85%;\n  max-height: 600px;\n  max-width: 430px;\n  min-width: 430px;\n  color: #000000;\n\n  --qds-theme-signature-color-default: ", ";\n  --qds-theme-signature-color-contrast: ", ";\n  --qds-theme-signature-color-hover: ", ";\n  --qds-theme-signature-color-pressed: ", ";\n\n  @media (max-width: 430px) {\n    min-width: 100%;\n    max-width: 100%;\n  }\n"])), function (props) {
  return props.color ? props.color : '#008a16';
}, function (props) {
  return props.textColor ? props.textColor : 'white';
}, function (props) {
  return props.hoverColor ? props.hoverColor : '#00611F';
}, function (props) {
  return props.hoverColor ? props.hoverColor : '#00611F';
});
var SurveyHeader = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n  padding: 10px;\n"])), function (props) {
  return props.color || "#008a16";
}, function (props) {
  return props.textColor || 'white';
});
var AppTitle = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: block;\n  font-weight: 400;\n  font-size: 16px;\n"])));
var IconWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  height: 30px;\n  margin-right: 10px;\n"])));
var FinishedIconWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 58px;\n  height: 58px;\n  color: ", ";\n"])), function (props) {
  return props.color || "#008a16";
});
var CloseIconWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  margin-left: 10px;\n  cursor: pointer;\n"])));
var SurveyContent = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0px;\n  padding: 20px 0px 20px 20px;\n  background-color: white;\n  overflow-x: hidden;\n  overflow-y: auto;\n"])));
var SurveyTitle = styled.span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: block;\n  font-weight: 700;\n  font-size: 16px;\n"])));
var ScrollablePadding = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  padding-right: 20px;\n  padding-bottom: 10px;\n"])));
var ButtonsWrapper = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 0px;\n  justify-content: space-between;\n  align-items: flex-end;\n  padding-right: 20px;\n  flex-wrap: wrap;\n"])));
var ButtonWrapper = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  margin-top: 10px;\n"])));
var CancelWrapper = styled(ButtonWrapper)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 0px;\n  justify-content: flex-end;\n  margin-left: 10px;\n"])));
var QuestionTitle = styled.span(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: block;\n  font-weight: 400;\n  font-size: 14px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  color: #000000;\n"])));
var DoneWrapper = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0px;\n  justify-content: center;\n  align-items: center;\n  padding-right: 20px;\n"])));
var DoneTitle = styled.span(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 20px;\n  color: #000000;\n  margin: 10px 0px;\n  text-align: center;\n"])));
var DoneSubtitle = styled.span(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 16px;\n  color: #000000;\n  text-align: center;\n"])));
var MandatoryStar = styled.span(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  color: #ED2B00;\n  font-size: 14px;\n"])));
var questionTypes = {
  grade: 'grade',
  dropdown: 'dropdown',
  textField: 'textField',
  radio: 'radio'
};
var surveySteps = {
  answering: 0,
  done: 1
};
var IACSurveyModal = /*#__PURE__*/function (_React$Component) {
  _inherits(IACSurveyModal, _React$Component);
  var _super = _createSuper(IACSurveyModal);
  function IACSurveyModal(props) {
    var _this;
    _classCallCheck(this, IACSurveyModal);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
    });
    _defineProperty(_assertThisInitialized(_this), "questionShouldBeDisplayed", function (question, currentAnswers) {
      var result = true;
      if (question.activeIf) {
        var previousQuestionKey = question.activeIf.previousQuestionKey;
        var previousAnswerValue = question.activeIf.previousAnswerValue;
        if (currentAnswers && currentAnswers[previousQuestionKey] && currentAnswers[previousQuestionKey].answer && currentAnswers[previousQuestionKey].answer.value !== previousAnswerValue) {
          result = false;
        }
      }
      return result;
    });
    _defineProperty(_assertThisInitialized(_this), "buildDefaultAnswers", function (defaultAnswers) {
      var useDefaultUserAnswers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var questions = [];
      if (_this.props.surveyData && _this.props.surveyData.questions) {
        questions = _this.props.surveyData.questions;
      }
      questions.forEach(function (question) {
        if (_this.questionShouldBeDisplayed(question, defaultAnswers) && (defaultAnswers[question.key] == null || defaultAnswers[question.key].activeIf && defaultAnswers[defaultAnswers[question.key].activeIf.previousQuestionKey] && defaultAnswers[defaultAnswers[question.key].activeIf.previousQuestionKey].answer && defaultAnswers[defaultAnswers[question.key].activeIf.previousQuestionKey].answer.value !== defaultAnswers[question.key].activeIf.previousAnswerValue)) {
          if (question.type === questionTypes.dropdown) {
            var possibleValues = question.values || [];
            if (possibleValues.length > 0) {
              var answer = possibleValues[0];

              // If the answer should be preselected, find it inside the possible values
              if (useDefaultUserAnswers && _this.props.preselectionnedAnswers && _this.props.preselectionnedAnswers[question.key]) {
                var userValue = possibleValues.find(function (val) {
                  return val.key === _this.props.preselectionnedAnswers[question.key];
                });
                if (userValue) {
                  answer = userValue;
                }
              }
              defaultAnswers[question.key] = {
                key: question.key,
                title: question.title,
                activeIf: question.activeIf,
                mandatory: question.mandatory,
                answer: {
                  title: answer.title,
                  value: answer.key
                }
              };
            }
          } else {
            defaultAnswers[question.key] = {
              key: question.key,
              title: question.title,
              activeIf: question.activeIf,
              mandatory: question.mandatory,
              answer: {
                value: null
              }
            };
          }
        }
      });
      return defaultAnswers;
    });
    _defineProperty(_assertThisInitialized(_this), "renderQuestion", function (question) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuestionTitle, null, _this.props.getLabel(question.key), " ", question.mandatory && /*#__PURE__*/React.createElement(MandatoryStar, null, "*")), question.type === questionTypes.dropdown && /*#__PURE__*/React.createElement(SurveyDropdown, {
        question: question,
        surveyAnswers: _this.state.surveyAnswers,
        getLabel: _this.props.getLabel,
        onChange: function onChange(newValue) {
          var newValues = JSON.parse(JSON.stringify(_this.state.surveyAnswers));
          var questionValues = question.values || [];
          if (questionValues.length > 0) {
            var selectedValue = questionValues.find(function (q) {
              return q.key === newValue;
            });
            if (selectedValue) {
              newValues[question.key] = {
                key: question.key,
                title: question.title,
                activeIf: question.activeIf,
                mandatory: question.mandatory,
                answer: {
                  title: selectedValue.title,
                  value: selectedValue.key
                }
              };
              _this.setState({
                surveyAnswers: _this.buildDefaultAnswers(newValues)
              });
            }
          }
        }
      }), question.type === questionTypes.textField && /*#__PURE__*/React.createElement(SurveyTextField, {
        value: _this.state.surveyAnswers[question.key] && _this.state.surveyAnswers[question.key].answer && _this.state.surveyAnswers[question.key].answer.value ? _this.state.surveyAnswers[question.key].answer.value : null,
        getLabel: _this.props.getLabel,
        onChange: function onChange(newValue) {
          var newValues = JSON.parse(JSON.stringify(_this.state.surveyAnswers));
          newValues[question.key] = {
            key: question.key,
            title: question.title,
            activeIf: question.activeIf,
            mandatory: question.mandatory,
            answer: {
              value: newValue
            }
          };
          _this.setState({
            surveyAnswers: _this.buildDefaultAnswers(newValues)
          });
        }
      }), question.type === questionTypes.grade && /*#__PURE__*/React.createElement(SurveyGrade, {
        value: _this.state.surveyAnswers[question.key] && _this.state.surveyAnswers[question.key].answer && _this.state.surveyAnswers[question.key].answer.value ? _this.state.surveyAnswers[question.key].answer.value : null,
        getLabel: _this.props.getLabel,
        onChange: function onChange(newValue) {
          var newValues = JSON.parse(JSON.stringify(_this.state.surveyAnswers));
          newValues[question.key] = {
            key: question.key,
            title: question.title,
            activeIf: question.activeIf,
            mandatory: question.mandatory,
            answer: {
              value: newValue
            }
          };
          _this.setState({
            surveyAnswers: _this.buildDefaultAnswers(newValues)
          });
        }
      }), question.type === questionTypes.radio && /*#__PURE__*/React.createElement(SurveyRadio, {
        question: question,
        answer: _this.state.surveyAnswers[question.key].answer,
        getLabel: _this.props.getLabel,
        onChange: function onChange(newValue) {
          var newValues = JSON.parse(JSON.stringify(_this.state.surveyAnswers));
          newValues[question.key].answer = newValue;
          _this.setState({
            surveyAnswers: _this.buildDefaultAnswers(newValues)
          });
        }
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderQuestions", function () {
      var questions = [];
      if (_this.props.surveyData && _this.props.surveyData.questions) {
        questions = _this.props.surveyData.questions;
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, _this.props.surveyData && _this.props.surveyData.key && /*#__PURE__*/React.createElement(SurveyTitle, null, _this.props.getLabel(_this.props.surveyData.key)), questions.filter(function (question) {
        return _this.questionShouldBeDisplayed(question, _this.state.surveyAnswers);
      }).map(function (question, idx) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: idx
        }, _this.renderQuestion(question));
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "canSubmit", function () {
      var canSubmit = true;
      var answers = Object.values(_this.state.surveyAnswers);
      for (var i = 0; i < answers.length && canSubmit; i++) {
        var answerObj = answers[i];
        if (answerObj.mandatory && (answerObj.answer.value == null || answerObj.answer.value === '')) {
          canSubmit = false;
        }
      }
      return canSubmit;
    });
    _defineProperty(_assertThisInitialized(_this), "buildSubmitPayload", function () {
      var result = [];
      var questions = [];
      if (_this.props.surveyData && _this.props.surveyData.questions) {
        questions = _this.props.surveyData.questions;
      }
      questions.forEach(function (question) {
        if (_this.questionShouldBeDisplayed(question, _this.state.surveyAnswers) && _this.state.surveyAnswers[question.key]) {
          result.push(_this.state.surveyAnswers[question.key]);
        }
      });
      return result;
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return /*#__PURE__*/React.createElement(SurveyBackground, {
        onClick: function onClick() {
          return _this.props.closeSurvey();
        }
      }, /*#__PURE__*/React.createElement(SurveyWrapper, {
        color: _this.props.color,
        textColor: _this.state.textColor,
        hoverColor: _this.state.hoverColor,
        onClick: function onClick(event) {
          event.stopPropagation(); // Prevent parent onClick to be triggered
        }
      }, /*#__PURE__*/React.createElement(SurveyHeader, {
        color: _this.props.color,
        textColor: _this.state.textColor
      }, /*#__PURE__*/React.createElement(AppTitle, null, _this.props.appTitle), /*#__PURE__*/React.createElement(CloseIconWrapper, {
        onClick: function onClick() {
          return _this.props.closeSurvey();
        }
      }, /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1024 1024"
      }, /*#__PURE__*/React.createElement("path", {
        fill: "currentColor",
        d: "M512.1,128.1c-212,0-384.1,172-384.1,383.9c0,212.2,172.1,383.9,384.1,383.9C724.2,895.9,896,724.2,896,512  C896,300.1,724.2,128.1,512.1,128.1z M674.6,674.7c-13.5,13.5-35.3,13.5-48.8,0c0,0,0,0,0,0L511.9,560.9L398.2,674.7  c-13.5,13.5-35.4,13.5-48.9,0c-13.4-13.5-13.4-35.4,0-48.9L463.1,512L349.3,398.2c-13.3-13.7-12.9-35.6,0.8-48.9  c13.4-13,34.7-13,48.1,0l113.7,113.8l113.8-113.8c13.5-13.5,35.4-13.5,48.9,0c13.5,13.5,13.5,35.4,0,48.9L560.8,512l113.8,113.8  c13.5,13.4,13.6,35.3,0.2,48.8C674.7,674.6,674.7,674.6,674.6,674.7z"
      }))))), /*#__PURE__*/React.createElement(SurveyContent, null, _this.state.step === surveySteps.answering && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Scrollbars, null, /*#__PURE__*/React.createElement(ScrollablePadding, null, _this.renderQuestions())), /*#__PURE__*/React.createElement(ButtonsWrapper, null, /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement(SurveyButton, {
        color: _this.props.color,
        textColor: _this.state.textColor,
        label: _this.props.getLabel('embedded_survey.cancel_generic'),
        onClick: function onClick() {
          return _this.props.closeSurvey();
        }
      })), /*#__PURE__*/React.createElement(CancelWrapper, null, /*#__PURE__*/React.createElement(SurveyButton, {
        importance: "emphasized",
        color: _this.props.color,
        textColor: _this.state.textColor,
        disabled: !_this.canSubmit(),
        label: _this.props.getLabel('embedded_survey.send_my_feedback_generic'),
        onClick: function onClick() {
          _this.props.onSubmit(_this.buildSubmitPayload());
          _this.setState({
            step: surveySteps.done
          });
          setTimeout(function () {
            if (_this._isMounted) {
              _this.props.closeSurvey();
            }
          }, 5000);
        }
      })))), _this.state.step === surveySteps.done && /*#__PURE__*/React.createElement(DoneWrapper, null, /*#__PURE__*/React.createElement(FinishedIconWrapper, {
        color: _this.props.color,
        textColor: _this.state.textColor
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1024 1024"
      }, /*#__PURE__*/React.createElement("path", {
        fill: "currentColor",
        d: "M512 128c212 0 384 172 384 384S724 896 512 896 128 724 128 512s172-384 384-384zm189 292c12-12 12-31 0-44-12-12-32-12-45 0L451 583l-83-85c-13-13-33-13-45 0-13 12-13 33 0 45l105 106c6 6 14 10 23 10 8 0 16-4 23-10z"
      }))), /*#__PURE__*/React.createElement(DoneTitle, null, _this.props.getLabel('embedded_survey.thank_you_generic')), /*#__PURE__*/React.createElement(DoneSubtitle, null, _this.props.getLabel('embedded_survey.your_feedback_is_valuable_generic'))))));
    });
    var standardizedColor = standardize_color(props.color || '#008a16');
    var rgbColor = hexToRgb(standardizedColor);
    var colorWithFilter = [Math.max(rgbColor[0] - 30, 0), Math.max(rgbColor[1] - 30, 0), Math.max(rgbColor[2] - 30, 0)];
    _this.state = {
      surveyAnswers: _this.buildDefaultAnswers({}, true),
      step: surveySteps.answering,
      textColor: rgb_is_light(hexToRgb(standardize_color(props.color || "#008a16"))) ? 'rgb(98,100,105)' : 'white',
      hoverColor: "rgb(".concat(colorWithFilter[0], ",").concat(colorWithFilter[1], ",").concat(colorWithFilter[2], ")")
    };
    _this._isMounted = false;
    return _this;
  }
  return _createClass(IACSurveyModal);
}(React.Component);
_defineProperty(IACSurveyModal, "propTypes", {
  surveyData: PropTypes.object,
  preselectionnedAnswers: PropTypes.object,
  getLabel: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  appTitle: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  closeSurvey: PropTypes.func.isRequired
});
export default IACSurveyModal;